import { render } from "./ChartComp.vue?vue&type=template&id=66e06887&scoped=true"
import script from "./ChartComp.vue?vue&type=script&lang=js"
export * from "./ChartComp.vue?vue&type=script&lang=js"

import "./ChartComp.vue?vue&type=style&index=0&id=66e06887&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e06887"]])

export default __exports__